import { useUnit } from 'effector-react'
import { useParams } from 'react-router'

import { $isCreatorProcessCompleted } from '@/models/creators.ts'
import { useTeamRole } from '@/modules/team/hooks/use-team-role'
import { TeamPageSkeleton } from '@/modules/team/ui/team-page-skeleton'
import { TeamRoleEdit } from '@/modules/team/views/roles/team-role-edit'

export const TeamRoleEditView = () => {
  const parameters = useParams<{ roleId: string }>()
  const roleId = Number(parameters.roleId)

  const { data, isFetching, isError } = useTeamRole(roleId)
  const isCreatorProcessCompleted = useUnit($isCreatorProcessCompleted)

  if (isNaN(roleId) || isError) {
    return (
      <div className="flex min-h-[400px] flex-col items-center justify-center gap-4">
        <h4 className="text-3xl text-yellow-600">Ooops...</h4>
        <p className="text-base text-white">
          We couldn&#39;t find any resouce for given role.
        </p>
      </div>
    )
  }

  if (isFetching || !data || !isCreatorProcessCompleted) {
    return <TeamPageSkeleton />
  }

  return <TeamRoleEdit role={data} />
}
